import { useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';
import PrintLink from '../PrintLink/PrintLink';
import HelpModal from '../HelpModal/HelpModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import { ChamProjectsOpenButton, ChamProjectsSaveButton } from '../ChamProjects/ChamProjects';

import styles from './TopMenu.module.css';
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';
import hollandLogo from './assets/holland-logo.png';

export default function TopMenu({ extended, onHelpClick, onReviewSelection }) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const menuRef = useRef(null);
    
    // TODO: Get these from Redux when visualizer is implemented
    // const currentView = useSelector(state => state.app.currentView);
    // const currentImageUrl = useSelector(state => state.app.currentImageUrl);
    // const style = useSelector(state => state.app.style);
    // const size = useSelector(state => state.app.size);
    // const activeProfile = useSelector(state => state.app.activeProfile);
    // const productSelection = useSelector(state => state.app.productSelection);
    // const roomscene = useSelector(state => state.app.roomscene);

    extended = true;

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const closeMenu = () => {
        setIsMobileMenuOpen(false);
    }

    const handleFeedbackModalButtonClick = function () {
        setIsFeedbackOpen(true);
        closeMenu();
    }

    const handleHelpButtonClick = function () {
        if (onHelpClick) {
            onHelpClick();
        } else {
            setIsHelpOpen(true);
        }
        closeMenu();
    }

    return (
        <>
            <section className={styles.topMenu} ref={menuRef}>
                <nav aria-label="Main Navigation">
                    <div className={styles.logo}>
                        <Link to="/" aria-label="Go to landing page">
                            <img src={hollandLogo} alt="Holland Homes" />
                        </Link>
                    </div>
                    <div className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </div>

                    <ul className={!isMobileMenuOpen ? styles.closed : ''}>
                        <div className={styles.rightNav}>
                            {extended && (<>
                                <li>
                                    <Link to="/" aria-label="Start Over">Start Over</Link>
                                </li>

                                <li>
                                    <ChamProjectsOpenButton title="My Projects" className="" aria-label="My Projects Button" />
                                </li>

                                <li>
                                    <ChamProjectsSaveButton title="Save" className="" aria-label="Save Button" />
                                </li>

                                <li>
                                    <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                        <span>Feedback</span>
                                    </button>
                                </li>

                                {/* <li>
                                    <button onClick={handleHelpButtonClick}>Help</button>
                                </li> */}

                                <li className={styles.altNav}>
                                    <PrintLink onClick={closeMenu} />
                                </li>

                                {onReviewSelection && (
                                    <li className={styles.ctaItem}>
                                        <button
                                            type="button"
                                            className={styles.ctaButton}
                                            onClick={() => { onReviewSelection(); closeMenu(); }}
                                            aria-label="Review Selection"
                                        >
                                            Review Selection
                                        </button>
                                    </li>
                                )}
                            </>)}
                        </div>
                    </ul>
                </nav>
            </section>

            <HelpModal
                isOpen={isHelpOpen}
                onClose={() => setIsHelpOpen(false)}
            />

            <FeedbackModal
                isOpen={isFeedbackOpen}
                onClose={() => setIsFeedbackOpen(false)}
            />
        </>
    );
}

